import RangeSlider from './RangeSlider';

export default RangeSlider;
export * from './types';
